import React, { Fragment } from 'react';
import { Dialog } from './../../common/dialog';
import Dropzone from 'react-dropzone';
import 'react-tippy/dist/tippy.css';
import { Tooltip } from 'react-tippy';
import numeral from 'numeral';

const FormModal = React.memo((props) => {
    const hideHandler = () => {
        props.setIdModal(null);
        props.hideFormModal();
        props.resetPromotionalItem();
        props.setImageFile(null);
    };

    const onDrop = (acceptedFiles) => {
        props.setImageFile(acceptedFiles[0]);
    };

    let previewImage = null;
    if (props.promotionalItem && props.promotionalItem.image_url) {
        previewImage = (
            <div className="current-image">
                <div>Current Preview Image:</div>
                <img src={props.promotionalItem.image_url} alt="" />
            </div>
        );
    }

    let currentPreviewLink = null;
    if (props.promotionalItem && props.promotionalItem.image_url) {
        currentPreviewLink = <div><a href={props.promotionalItem.image_url} target="_blank" rel="noopener noreferrer">View Current Image <i className="fas fa-external-link-alt" /></a></div>;
    }

    const handleFieldChange = (field, event) => {
        props.setPromotionalItemField(field, event.target.value);
    };

    let buttonLabel = 'Save';
    if (props.saving) {
        buttonLabel = <i className="fas fa-circle-notch fa-spin" />;
    }

    const handleSetPrice = (index, event) => {
        props.setPrice(index, event.target.value);
    };

    const handleSetEnabled = (index, event) => {
        props.setEnabled(index, event.target.checked ? 1 : 0);
    };

    const renderPricing = () => {
        if (props.promotionalItem == null) {
            return null;
        }

        let rows = [];
        for (let i = 1; i <= 10; i++) {
            let totalQuantity = i;
            let quantityLabel = i;
            if (parseInt(props.promotionalItem.is_bundles) === 1) {
                let bundleName = i === 1 ? 'bundle' : 'bundles';
                quantityLabel = i + ' ' + bundleName + ' (' + numeral(i * props.promotionalItem.pieces_per_bundle).format('0,0') + ' pieces)';
                totalQuantity = i * props.promotionalItem.pieces_per_bundle;
            }

            rows.push(
                <tr>
                    <td style={{width: 30}}>
                        <input
                            type="checkbox"
                            value={props.promotionalItem.pricing_enabled[i - 1]}
                            checked={props.promotionalItem.pricing_enabled[i - 1]}
                            onChange={handleSetEnabled.bind(this, i - 1)}
                        />
                    </td>
                    <td>{quantityLabel}</td>
                    <td>
                        <input
                            type="number"
                            value={props.promotionalItem.pricing[i - 1]}
                            onChange={handleSetPrice.bind(this, i - 1)}
                        />
                    </td>
                    <td>{numeral(props.promotionalItem.pricing[i - 1] / totalQuantity).format('$0,0.00')}</td>
                </tr>
            );
        }
        return rows;
    };

    let actions = [
        <button key="save-button" className="btn btn-light btn-sm action-button" onClick={props.savePromotionalItem}>{buttonLabel}</button>,
        <button key="cancel-button" className="btn btn-light btn-sm action-button-cancel" onClick={hideHandler}>Close</button>
    ];
    return (
        <Dialog
            name="form-modal"
            modal={false}
            actions={actions}
            contentStyle={{ width: 1000 }}
            bodyStyle={{ overflow: 'initial' }}
            className="admin-promotional-items-form-modal-dialog"
        >
            <div className="admin-promotional-items-form-modal-container">
                <div className="title">Promotional Item</div>
                <div className="subtitle">Information</div>
                <div className="info-fields">
                    <div className="field sku-field">
                        <div className="label">SKU <span className="required">*</span>:</div>
                        <input type="text" value={props.promotionalItem.sku} onChange={handleFieldChange.bind(this, 'sku')} />
                    </div>
                    <div className="field name-field">
                        <div className="label">Name <span className="required">*</span>:</div>
                        <input type="text" value={props.promotionalItem.name} onChange={handleFieldChange.bind(this, 'name')} />
                    </div>
                    <div className="field vendor-field">
                        <div className="label">Vendor Product Code:</div>
                        <input type="text" value={props.promotionalItem.vendor_product_code} onChange={handleFieldChange.bind(this, 'vendor_product_code')} />
                    </div>
                    <div className="field description-field">
                        <div className="label">Description:</div>
                        <input type="text" value={props.promotionalItem.description} onChange={handleFieldChange.bind(this, 'description')} />
                    </div>
                    <div className="field department-field">
                        <div className="label">Department <span className="required">*</span>:</div>
                        <select value={props.promotionalItem.uthealth_department_id} onChange={handleFieldChange.bind(this, 'uthealth_department_id')}>
                            <option value="">Select option</option>
                            {props.departments.map((department) => {
                                return <option key={department.id} value={department.id}>{department.name}</option>
                            })}
                        </select>
                    </div>
                    <div className="small-field">
                        <div className="label">Current Inventory <span className="required">*</span>:</div>
                        <input type="text" value={props.promotionalItem.current_inventory} onChange={handleFieldChange.bind(this, 'current_inventory')} />
                    </div>
                    <div className="small-field">
                        <div className="label">Use Bundles <span className="required">*</span>:</div>
                        <select value={props.promotionalItem.is_bundles} onChange={handleFieldChange.bind(this, 'is_bundles')}>
                            <option value="1">Yes</option>
                            <option value="0">No</option>
                        </select>
                    </div>
                    <div className="small-field">
                        <div className="label">Pieces/Bundle:</div>
                        <input
                            type="text"
                            value={props.promotionalItem.pieces_per_bundle}
                            onChange={handleFieldChange.bind(this, 'pieces_per_bundle')}
                            disabled={!parseInt(props.promotionalItem.is_bundles)}
                        />
                    </div>
                    <div className="small-field sku-charge-field">
                        <div className="label">SKU Charge <span className="required">*</span>:</div>
                        <input type="text" value={props.promotionalItem.sku_charge} onChange={handleFieldChange.bind(this, 'sku_charge')} />
                    </div>
                    <div className="small-field">
                        <div className="label">Shipping Charge <span className="required">*</span>:</div>
                        <input type="text" value={props.promotionalItem.shipping_charge} onChange={handleFieldChange.bind(this, 'shipping_charge')} />
                    </div>
                    <div className="small-field">
                        <div className="label">Handling Charge <span className="required">*</span>:</div>
                        <input type="text" value={props.promotionalItem.handling_charge} onChange={handleFieldChange.bind(this, 'handling_charge')} />
                    </div>
                    <div className="small-field">
                        <div className="label">Logos Options <span className="required">*</span>:</div>
                        <select value={props.promotionalItem.show_logos} onChange={handleFieldChange.bind(this, 'show_logos')}>
                            <option value="">Select option</option>
                            <option value="1">Only UTP</option>
                            <option value="2">Only UTHH</option>
                            <option value="3">All UTHH</option>
                        </select>
                    </div>
                </div>
                <div className="subtitle">File</div>
                <div className="file-fields">
                    <div className="dropzones">
                        <Dropzone onDrop={onDrop} accept="image/png, image/jpg, image/jpeg">
                            {({ getRootProps, getInputProps }) => (
                                <div className="preview-dropzone-container">
                                    <div className="label">
                                        Preview Image <span className="required">*</span>:
                                        <Tooltip title="The Preview image that will be displayed in the tile and description of the Item. It needs to be a PNG or JPG image, with a good resolution for web. 500px to 800px recommended." position="top" arrow size="small" className="info-tooltip">
                                            <i className="fas fa-question-circle" />
                                        </Tooltip>
                                    </div>
                                    <div {...getRootProps()} className="button">
                                        <input {...getInputProps()} />
                                        <p>Click here to upload a file</p>
                                    </div>
                                    {currentPreviewLink}
                                    <div className="file-name">
                                        {props.imageFile != null ? <Fragment><b>Selected File:</b> {props.imageFile.name}</Fragment> : null}
                                    </div>
                                </div>
                            )}
                        </Dropzone>
                    </div>
                    {previewImage}
                    <div className="pricing-container">
                        <h4>Pricing</h4>
                        <table className="table table-sm table-hover table-striped">
                            <thead>
                                <tr>
                                    <th></th>
                                    <th>Quantity</th>
                                    <th>Price</th>
                                    <th>Each</th>
                                </tr>
                            </thead>
                            <tbody>{renderPricing()}</tbody>
                        </table>
                    </div>
                </div>
                <div className="subtitle">Information Bullets</div>
                <div className="description-fields">
                    <div className="field">
                        <div className="label">Bullet 1:</div>
                        <input type="text" value={props.promotionalItem.bullet1} onChange={handleFieldChange.bind(this, 'bullet1')} />
                    </div>
                    <div className="field">
                        <div className="label">Bullet 2:</div>
                        <input type="text" value={props.promotionalItem.bullet2} onChange={handleFieldChange.bind(this, 'bullet2')} />
                    </div>
                    <div className="field">
                        <div className="label">Bullet 3:</div>
                        <input type="text" value={props.promotionalItem.bullet3} onChange={handleFieldChange.bind(this, 'bullet3')} />
                    </div>
                    <div className="field">
                        <div className="label">Bullet 4:</div>
                        <input type="text" value={props.promotionalItem.bullet4} onChange={handleFieldChange.bind(this, 'bullet4')} />
                    </div>
                    <div className="field">
                        <div className="label">Bullet 5:</div>
                        <input type="text" value={props.promotionalItem.bullet5} onChange={handleFieldChange.bind(this, 'bullet5')} />
                    </div>
                    <div className="field">
                        <div className="label">Bullet 6:</div>
                        <input type="text" value={props.promotionalItem.bullet6} onChange={handleFieldChange.bind(this, 'bullet6')} />
                    </div>
                    <div className="field">
                        <div className="label">Bullet 7:</div>
                        <input type="text" value={props.promotionalItem.bullet7} onChange={handleFieldChange.bind(this, 'bullet7')} />
                    </div>
                    <div className="field">
                        <div className="label">Bullet 8:</div>
                        <input type="text" value={props.promotionalItem.bullet8} onChange={handleFieldChange.bind(this, 'bullet8')} />
                    </div>
                    <div className="field">
                        <div className="label">Bullet 9:</div>
                        <input type="text" value={props.promotionalItem.bullet9} onChange={handleFieldChange.bind(this, 'bullet9')} />
                    </div>
                    <div className="field">
                        <div className="label">Bullet 10:</div>
                        <input type="text" value={props.promotionalItem.bullet10} onChange={handleFieldChange.bind(this, 'bullet10')} />
                    </div>
                </div>
                <div className="subtitle">Permissions</div>
                <div className="permission-fields">
                    <div className="field">
                        <div className="label">
                            Show for UTP <span className="required">*</span>:
                            <Tooltip title="This field controls the visibility of this Form in the UTP platform for Admins, Regular Users and Approvers" position="top" arrow size="small" className="info-tooltip">
                                <i className="fas fa-question-circle" />
                            </Tooltip>
                        </div>
                        <select value={props.promotionalItem.allow_utp} onChange={handleFieldChange.bind(this, 'allow_utp')}>
                            <option value="1">Yes</option>
                            <option value="0">No</option>
                        </select>
                    </div>
                    <div className="field">
                        <div className="label">
                            Show for UTH <span className="required">*</span>:
                            <Tooltip title="This field controls the visibility of this Form in the UTH platform for Admins, Regular Users and Approvers" position="top" arrow size="small" className="info-tooltip">
                                <i className="fas fa-question-circle" />
                            </Tooltip>
                        </div>
                        <select value={props.promotionalItem.allow_uth} onChange={handleFieldChange.bind(this, 'allow_uth')}>
                            <option value="1">Yes</option>
                            <option value="0">No</option>
                        </select>
                    </div>
                    <div className="field">
                        <div className="label">
                            Show for Manager <span className="required">*</span>:
                            <Tooltip title="This field controls the visibility of this Form in the Managers section" position="top" arrow size="small" className="info-tooltip">
                                <i className="fas fa-question-circle" />
                            </Tooltip>
                        </div>
                        <select value={props.promotionalItem.allow_manager} onChange={handleFieldChange.bind(this, 'allow_manager')}>
                            <option value="1">Yes</option>
                            <option value="0">No</option>
                        </select>
                    </div>
                    <div className="field">
                        <div className="label">
                            Show for Personal <span className="required">*</span>:
                            <Tooltip title="This field controls the visibility of this Form in the Personal Purchases platform" position="top" arrow size="small" className="info-tooltip">
                                <i className="fas fa-question-circle" />
                            </Tooltip>
                        </div>
                        <select value={props.promotionalItem.allow_personal} onChange={handleFieldChange.bind(this, 'allow_personal')}>
                            <option value="1">Yes</option>
                            <option value="0">No</option>
                        </select>
                    </div>
                    <div className="field">
                        <div className="label">
                            Show for Coupa <span className="required">*</span>:
                            <Tooltip title="This field controls the visibility of this Form for the users coming from Coupa" position="top" arrow size="small" className="info-tooltip">
                                <i className="fas fa-question-circle" />
                            </Tooltip>
                        </div>
                        <select value={props.promotionalItem.allow_coupa} onChange={handleFieldChange.bind(this, 'allow_coupa')}>
                            <option value="1">Yes</option>
                            <option value="0">No</option>
                        </select>
                    </div>
                </div>
            </div>
        </Dialog >
    );
});

export default FormModal;
